//noinspection JSUnusedGlobalSymbols
export default {

    all: state => Object.values(state.entities),

    allByCompanyId: (state, getters) => companyId => {
        return getters['all'].filter(person => person.company === companyId)
    },

    allByBelongsToZmuek: (state, getters) => {
        return getters['allByCompanyId'](2)
    },

    allByUsers: (state, getters) => users => {
        return users.map(user => getters['all'].find(person => person.id === user.person))
    },

    byId: state => id => {
        return state.entities[id]
    },

    byUserId: (state, getters) => userId => {
        return getters['all'].find(person => person.user === userId)
    },

    counts: state => state.counts,

}


